import React, { useState } from 'react';
import { Button, Menu, MenuItem, ListItemIcon, ListItemText, Divider } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import EditIcon from '@mui/icons-material/Edit';

/**
 * ConversationActions (#8) — a single "Actions" dropdown that collapses scene
 * steering, difficulty adjustment, and a custom "Other" scenario into one menu.
 *
 * Emits onSelectAction(id) for every item. The parent routes:
 *   move_on/switch_scene/change_topic/wrap_up/ask_help -> scene action
 *   make_easier/make_harder                            -> difficulty adjustment
 *   custom                                             -> open a "set the scene" dialog
 *
 * CONVERSATION_ACTIONS (the scene-steering taxonomy) is exported for the parent's
 * transcript-marker labels.
 */
export const CONVERSATION_ACTIONS = [
  { id: 'move_on', label: 'Move on', icon: <ArrowForwardIcon fontSize="small" /> },
  { id: 'switch_scene', label: 'Switch scene', icon: <SwapHorizIcon fontSize="small" /> },
  { id: 'change_topic', label: 'Change topic', icon: <AutorenewIcon fontSize="small" /> },
  { id: 'wrap_up', label: 'Wrap up', icon: <CheckCircleOutlineIcon fontSize="small" /> },
  { id: 'ask_help', label: 'Ask for help', icon: <HelpOutlineIcon fontSize="small" /> },
];

export default function ConversationActions({ onSelectAction, disabled = false }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handlePick = (id) => {
    handleClose();
    onSelectAction(id);
  };

  return (
    <>
      <Button
        size="small"
        variant="outlined"
        disabled={disabled}
        onClick={handleOpen}
        endIcon={<KeyboardArrowDownIcon />}
        sx={{ textTransform: 'none', borderRadius: 4 }}
      >
        Actions
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        {CONVERSATION_ACTIONS.map((a) => (
          <MenuItem key={a.id} onClick={() => handlePick(a.id)}>
            <ListItemIcon>{a.icon}</ListItemIcon>
            <ListItemText>{a.label}</ListItemText>
          </MenuItem>
        ))}
        <Divider />
        <MenuItem onClick={() => handlePick('make_easier')}>
          <ListItemIcon><TrendingDownIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Make easier</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handlePick('make_harder')}>
          <ListItemIcon><TrendingUpIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Make harder</ListItemText>
        </MenuItem>
        <Divider />
        <MenuItem onClick={() => handlePick('custom')}>
          <ListItemIcon><EditIcon fontSize="small" /></ListItemIcon>
          <ListItemText>Other (set the scene…)</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
}
